export { getAvatarBackground } from "./get-avatar-background";
